/**
 * @author caijianjia
 * @date 2020/4/7 8:20 下午
 */
import CompImgBox from './CompImgBox'
import CompVideoBox from './CompVideoBox'

import IMShareCourse from './ShareCourse'
import IMVoiceConfig from './VoiceConfig'
import IMTable from './IMTable'
import IMForm from './IMForm'
import FileDialog from './FileDialog'
import RowBox from './RowBox'
import RowChildrenBox from './RowChildrenBox'
import VoiceChange from './VoiceChange'
import FeedBack from './FeedBack'


const components = {
    CompImgBox,
    CompVideoBox,
    IMShareCourse,
    IMVoiceConfig,
    IMTable,
    IMForm,
    FileDialog,
    RowBox,
    RowChildrenBox,
    VoiceChange,
    FeedBack
}

export default Vue => Object.keys(components)
    .forEach(key => Vue.component(key, components[key]))
